import axiosHttp from "services/axiosHttp";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { message } from "antd";

// Action for fetching inventory summary from the new endpoint
export const fetchProductItemUpload = createAsyncThunk("fetchProductItemUpload", async ({ channel, file, type }, { rejectWithValue }) => {
	try {
		const formData = new FormData();
		formData.append("channel", channel);
		formData.append("file", file);
		const response = await axiosHttp.post(`products/item/upload`, formData);
		message.success("Inventory uploaded successfully!");
		return response.data.data;
	} catch (error) {
		return rejectWithValue(error.response?.data);
	}
});

const RewardProductItemUploadSlice = createSlice({
	name: "RewardProductItemUploadSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},

	reducers: {
		resetRewardProductItemUploadSlice: (state) => {
			state.isLoading = false;
			state.isError = false;
			state.error = null;
			state.data = null;
		},
	},

	extraReducers: (builder) => {
		builder.addCase(fetchProductItemUpload.pending, (state) => {
			state.isLoading = true;
			state.error = null; // Clear any previous error on new request
		});

		builder.addCase(fetchProductItemUpload.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload; // Adjust based on response structure
		});

		builder.addCase(fetchProductItemUpload.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload || "Unknown error occurred";
		});
	},
});

export default RewardProductItemUploadSlice.reducer;
export const { resetRewardProductItemUploadSlice } = RewardProductItemUploadSlice.actions;
